import { render, staticRenderFns } from "./InternalApiConfiguration.vue?vue&type=template&id=f8c5a302&"
import script from "./InternalApiConfiguration.vue?vue&type=script&lang=ts&"
export * from "./InternalApiConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports